import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.black2};
    transition: background-color 0.3s ease;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
`;

export const IconWrapper = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  padding: 0px 2px;
  justify-content: center;
  align-items: center;
`;

export const Type = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const CourseName = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const NumberWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const PercentageWrapper = styled.div`
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
`;
